<template>
  <div class="w-full flex flex-row gap-4 pb-12 mb-12 type-headline-sm leading-single border-b border-border-subtle">
    <span> {{ userStore.userProfile.company.name }} </span>
    <span class="text-text-subtle font-normal"> #{{ userStore.userProfile.company.code }} </span>
  </div>
  <div class="flex justify-between">
    <div class="flex items-center gap-12">
      <!-- Avatar -->
      <div
        class="w-40 h-40 desk:w-48 desk:h-48 flex flex-col items-center justify-center shrink-0 rounded-full"
        :class="{
          'bg-bg-success': userStore.isSalesRepUser || userStore.isCountryManagerUser,
          'bg-bg-attention': userStore.isLoggedIn && !userStore.isSalesRepUser && !userStore.isCountryManagerUser,
          'bg-warningLight': userStore.isCustomerSuccessUser,
        }"
      >
        <!-- Sales rep / country manager -->
        <img
          v-if="userStore.isSalesRepUser || userStore.isCountryManagerUser"
          alt="staff"
          src="/icons/smiley-cool-success.svg"
          class="w-[26px] h-[26px] desk:w-32 desk:h-32"
        >
        <!-- Customer -->
        <img
          v-if="userStore.isLoggedIn && !userStore.isSalesRepUser && !userStore.isCountryManagerUser && !userStore.isCustomerSuccessUser"
          alt="customer"
          src="/icons/smiley-attention.svg"
          class="w-24 h-24 desk:w-32 desk:h-32"
        >
        <!-- Customer service -->
        <img
          v-if="userStore.isCustomerSuccessUser"
          alt="customer service"
          src="/icons/headset-warning.svg"
          class="w-24 h-24 desk:w-32 desk:h-32"
        >
      </div>

      <!-- Name -->
      <div class="shrink type-headline-sm leading-single">
        <div class="line-clamp-1">
          <!-- Sales rep and Customer -->
          <div
            v-if="userStore.isLoggedIn && !userStore.isCustomerSuccessUser"
            class="flex flex-col gap-4"
          >
            <span class="line-clamp-1">{{ userStore.userProfile.firstName }} {{ userStore.userProfile.lastName }}</span>
            <span class="font-normal text-text-subtle">{{ userStore.userProfile.email }}</span>
          </div>
          <!-- Customer service -->
          <div
            v-else
            class="flex flex-col gap-4"
          >
            <span class="line-clamp-1">{{ userStore.userProfile.lastName }}</span>
            <span class="font-normal text-dark">{{ userStore.userProfile.email }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- Onboarding - about my pages -->
    <div class="flex flex-row deskStd:hidden gap-2 shrink-0">
      <button
        class="flex items-center justify-center p-8"
        :class="{'hidden': userStore.isCustomerSuccessUser}"
        type="button"
        :aria-label="$t('mypage.user.onboarding')"
        @click="$emit('show', 'onboarding')"
      >
        <img
          src="/icons/info.svg"
          class="w-24 h-24"
          aria-hidden="true"
        >
      </button>
      <!-- Sign out -->
      <button
        class="flex items-center justify-center p-8"
        type="button"
        :aria-label="$t('mypage.logout')"
        @click="userStore.logOut"
      >
        <img
          src="/icons/sign-out.svg"
          class="w-24 h-24"
          aria-hidden="true"
        >
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">

import { useUserStore } from '~/store/user';

const userStore = useUserStore();

</script>
